import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const MATRIMONY_BASE_URL =
  `${API_BASE_URL}/matrimony`;

// ==========================
// GET MATRIMONY PROFILE
// ==========================
export const getMatrimonyProfileApi = async (
  id: number | string
) => {
  try {
    const res = await axios.get(
      `${MATRIMONY_BASE_URL}/${id}`
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      status: false,
      data: null,
      message:
        error?.response?.data?.message ||
        "Failed to load matrimony profile",
    };
  }
};
